import findIndex from 'lodash/findIndex'

export default function (state = {}, action) {
	switch (action.type) {
	
   
    case 'SIGN_OUT':
      return {}
   
    case 'FETCH_USER_SETTINGS_SUCCESS':
     case 'UPDATE_USER_SETTINGS_SUCCESS':
      return action.response


    default:
      return state;
	}
}

